import { Button } from '@salesforce/design-system-react';
import React from 'react';
import { toast } from 'react-hot-toast';

const TokenDetails = ({ data }) => {
  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    toast.success('Successfully Copied');
  };

  return (
    <>
      {data.sends && data.sends?.length > 0 && (
        <div className="home_card">
          <div className="slds-grid slds-grid_pull-padded slds-grid_vertical-align-center">
            <div className="transaction_detail_half_details">
              <div className="flex items-center">
                <h6 style={{ fontWeight: '700' }}>Token Sent</h6>
              </div>
              {data.sends.length > 0
                ? data.sends.map((item) => {
                    return (
                      <div className="mt-2 cursor-pointer" title={item?.token_id}>
                        {item.token_name}
                      </div>
                    );
                  })
                : '--'}
            </div>
            <div
              className="transaction_detail_half_details"
              style={{
                marginRight: '15px',
                textAlign: 'right',
              }}
            >
              {data.sends.map((item) => {
                return (
                  <div className="mt-2">
                    <Button
                      style={{ marginBottom: 10 }}
                      key="copy"
                      label="Copy"
                      onClick={() => handleCopy(item.token_id)}
                      iconCategory="utility"
                      iconName="copy"
                      iconPosition="left"
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
      {data.receives && (
        <div className="home_card">
          <div className="slds-grid slds-grid_pull-padded slds-grid_vertical-align-center">
            <div className="transaction_detail_half_details">
              <div>
                <div className="flex items-center">
                  <h6 style={{ fontWeight: '700' }}>Token Received</h6>
                </div>
                {data.receives.length
                  ? data.receives.map((item) => {
                      return (
                        <div className="mt-2 cursor-pointer" title={item?.token_id}>
                          {item.token_name}
                        </div>
                      );
                    })
                  : '--'}
              </div>
            </div>
            <div
              className="transaction_detail_half_details"
              style={{
                marginRight: '15px',
                textAlign: 'right',
              }}
            >
              {data.receives.map((item) => {
                return (
                  <div className="mt-2">
                    <Button
                      style={{ marginBottom: 10 }}
                      key="copy"
                      label="Copy"
                      onClick={() => handleCopy(item.token_id)}
                      iconCategory="utility"
                      iconName="copy"
                      iconPosition="left"
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
      {data.token_approve && (
        <div className="home_card">
          <div className="slds-grid slds-grid_pull-padded slds-grid_vertical-align-center">
            <div className="transaction_detail_half_details">
              <div>
                <div className="flex items-center">
                  <h6 style={{ fontWeight: '700' }}>Token Approved</h6>
                </div>
                {data.token_approve.length
                  ? data.token_approve.map((item) => {
                      return (
                        <div className="mt-2 cursor-pointer" title={item?.token_id}>
                          {item.token_name}
                        </div>
                      );
                    })
                  : '--'}
              </div>
            </div>
            <div
              className="transaction_detail_half_details"
              style={{
                marginRight: '15px',
                textAlign: 'right',
              }}
            >
              {data.token_approve.map((item) => {
                return (
                  <div className="mt-2">
                    <Button
                      style={{ marginBottom: 10 }}
                      key="copy"
                      label="Copy"
                      onClick={() => handleCopy(item.token_id)}
                      iconCategory="utility"
                      iconName="copy"
                      iconPosition="left"
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TokenDetails;
